import {
  ContentWrapper,
  DoneButton,
  DoneButtonText,
  DoneButtonTextWrapper,
  TicketInfoWrapper,
} from './TicketInfo.styled';
import { TicketInfoField } from './TicketInfoField/TicketInfoField';
import { CreatedOnField } from './CreatedOnField/CreatedOnField';
import { DescriptionField } from './DescriptionField/DescriptionField';
import { StatusField } from './StatusField/StatusField';
import { OwnerField } from './OwnerField/OwnerField';
import { ApprovalField } from './ApprovalField/ApprovalField';
import { RequestedDueDateField } from './RequestDueDateField/RequestedDueDateField';
import { TypeField } from './TypeField/TypeField';
import {
  ticketCategoryLookUp,
  ticketPriorityLookUp,
  ticketTypeLookUp,
} from 'src/components/Tickets/MyTickets.constants';
import { SingleTicketTransformed } from 'src/components/Tickets/models/Tickets.interface';

interface TicketInfoProps {
  ticketInfo: Partial<SingleTicketTransformed>;
  onClose: () => void;
  ticketOwner: string;
}
export const TicketInfo = ({
  ticketInfo,
  onClose,
  ticketOwner,
}: TicketInfoProps) => {
  return (
    <TicketInfoWrapper>
      <ContentWrapper>
        <TicketInfoField
          labelText="Ticket ID"
          displayValue={ticketInfo?.new_id}
        />
        <CreatedOnField date={ticketInfo?.createdon} />
        <RequestedDueDateField date={ticketInfo?.new_requestedduedate} />
        <DescriptionField displayValue={ticketInfo?.new_description} />
        <TypeField
          ticketType={ticketTypeLookUp[ticketInfo?.new_tickettype]?.label}
          icon={ticketTypeLookUp[ticketInfo?.new_tickettype]?.icon}
        />
        <TicketInfoField
          labelText="Category"
          displayValue={
            ticketCategoryLookUp[ticketInfo?._new_category_value]?.label
          }
        />
        <TicketInfoField
          labelText="Priority"
          displayValue={ticketPriorityLookUp[ticketInfo?.new_priority]?.label}
        />
        <ApprovalField approval={ticketInfo?.new_approvalstatus} />
        <OwnerField owner={ticketInfo?.owner ?? ticketOwner} />
        <StatusField status={ticketInfo?.statuscode} />
      </ContentWrapper>
      <DoneButton
        shape="rounded"
        appearance="outline"
        size="medium"
        onClick={onClose}
      >
        <DoneButtonTextWrapper>
          <DoneButtonText>Done</DoneButtonText>
        </DoneButtonTextWrapper>
      </DoneButton>
    </TicketInfoWrapper>
  );
};
